module.exports = __webpack_public_path__ + "media/newstyle/images/icon-lp-2-red-fe51c5ea388fa278ea6cf684364203d1.svg";